export default __webpack_public_path__ + "static/media/MJE_image1.0d778d3e.png";